var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9525 4.80996V2.74354H4.52077L12.4244 11.2443C12.9193 11.7771 12.9126 12.6053 12.4086 13.1291L4.59413 21.2566H17.9522V20.0086C17.9522 19.2524 18.5674 18.6372 19.3238 18.6372C20.08 18.6372 20.6959 19.2524 20.6959 20.0086V22.628C20.6959 23.3844 20.0803 24 19.3238 24H1.37224C0.821763 24 0.326061 23.6727 0.110105 23.1656C-0.10595 22.6588 0.00160661 22.0746 0.38316 21.6774L9.53212 12.1626L0.367498 2.30583C-0.00384549 1.90593 -0.103174 1.32453 0.114665 0.823874C0.332752 0.323413 0.826571 0 1.37224 0H19.3242C20.0803 0 20.6961 0.615254 20.6961 1.37197V4.80996C20.6961 5.56628 20.0806 6.18178 19.3242 6.18178C18.5677 6.18178 17.9525 5.56658 17.9525 4.80996Z",
    fill: "#2487FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum);
export default __webpack_public_path__ + "static/media/sum.8455589fb0e17bb3e5fd2db64011424e.svg";
export { ForwardRef as ReactComponent };